<template>
    <h4 class="adv-title"><slot></slot></h4>
</template>
<script>
export default {
    name: 'AdvTitle'
};
</script>

<style lang="scss">
@import '@/theme/media.scss';
.adv-title {
    font-size: 18px;
    font-weight: 600;
    line-height: 1.33;
    text-align: center;
    color: #202437;
    margin: 0;
    @include media-600 {
        font-size: 20px;
        line-height: 23px;
        font-family: var(--font-bold);
        margin-bottom: 10px;
    }
}
</style>
